module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.b70b6ac5.png";